import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { PaymentSession } from '../../views/admin/interfaces';
import { useI18n } from '../../i18n/I18n';

interface QRModalProps {
    session: PaymentSession;
    onClose: () => void;
    onCopyLink: (sessionId: string) => void;
    onDownloadPDF: (sessionId: string, sessionName?: string) => void;
}

export default function QRModal({ session, onClose, onCopyLink, onDownloadPDF }: QRModalProps) {
    const { t } = useI18n();

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-6" onClick={onClose}>
            <div className="absolute inset-0 backdrop-blur-xl" style={{ background: 'var(--color-overlay)' }} />
            <div
                className="relative glass-panel rounded-2xl p-6 w-full max-w-[320px] border border-white/15 shadow-2xl animate-in fade-in zoom-in duration-200"
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 w-8 h-8 rounded-full border-none flex items-center justify-center cursor-pointer transition-colors" style={{ background: 'var(--color-surface)' }}
                >
                    <span className="material-symbols-outlined text-txt-muted hover:text-txt-heading text-[18px]">close</span>
                </button>

                <div className="text-center mb-5">
                    <h3 className="text-txt-heading font-bold text-[17px] leading-tight">
                        {session.concept || session.template || 'Link de Pago'}
                    </h3>
                    <p className="text-txt-secondary text-[12px] mt-1">{t('pos.scanToPay')}</p>
                </div>

                <div className="flex justify-center">
                    <div className="bg-white rounded-2xl p-4 shadow-lg shadow-electric-blue/10">
                        <QRCodeCanvas
                            value={`https://pay.sprintcheckout.com/?uid=${session.sessionId}`}
                            size={200}
                            level="H"
                            includeMargin={false}
                            style={{ display: 'block' }}
                        />
                    </div>
                </div>

                <div className="flex justify-center mt-5">
                    <div className="bg-accent-purple/15 text-accent-purple text-[13px] font-bold px-4 py-2 rounded-xl border border-accent-purple/20 tracking-wide">
                        {session.amount} {session.currency}
                    </div>
                </div>

                <div className="flex gap-3 mt-5">
                    <button
                        onClick={() => onCopyLink(session.sessionId!)}
                        className="flex-1 glass-btn py-2.5 rounded-xl flex items-center justify-center gap-2 text-[12px] font-semibold text-txt-secondary hover:text-txt-heading transition-all border-none cursor-pointer"
                    >
                        <span className="material-symbols-outlined text-[16px]">link</span>
                        {t('pos.copyLinkBtn')}
                    </button>
                    <button
                        onClick={() => onDownloadPDF(session.sessionId!, session.name || session.concept || '')}
                        className="flex-1 glass-btn py-2.5 rounded-xl flex items-center justify-center gap-2 text-[12px] font-semibold text-txt-secondary hover:text-txt-heading transition-all border-none cursor-pointer"
                    >
                        <span className="material-symbols-outlined text-[16px]">download</span>
                        {t('pos.download')}
                    </button>
                </div>
            </div>
        </div>
    );
}
